<div class="profile-menu-container">
  <div class="menu-header">
    <div class="user-avatar">
      <img
        [src]="currentuser?.photoURL || './assets/landingpage/Avatar.png'"
        alt="User Avatar"
        onerror="this.src='./assets/landingpage/Avatar.png'"
      />
    </div>
    <div class="user-info">
      <h4>{{ currentuser?.firstname || 'User' }}</h4>
      <p>
        {{ currentuser?.accountdetails?.companyname || currentuser?.role || 'Guest' }}
      </p>
      <span
        class="plan-badge"
        *ngIf="planName"
        [style.background]="planColor + '18'"
        [style.border-color]="planColor + '50'"
        [style.color]="planColor"
      >
        <i class="fa-solid fa-crown"></i>
        {{ planName }}
      </span>
    </div>
  </div>

  <div class="menu-divider"></div>

  <div class="menu-actions">
    <button class="menu-item" (click)="navigate()" *ngIf="currentuser?.role !== 'worker'">
      <div class="icon-wrap">
        <i class="fa-regular fa-user"></i>
      </div>
      <span>My Profile</span>
    </button>

    <div class="menu-item worker-badge" *ngIf="currentuser?.role === 'worker'">
      <div class="icon-wrap">
        <i class="fa-solid fa-user-tie"></i>
      </div>
      <span>Worker Account</span>
    </div>

    <button class="menu-item logout" (click)="userSignOut()">
      <div class="icon-wrap">
        <i class="fa-solid fa-arrow-right-from-bracket"></i>
      </div>
      <span>Sign Out</span>
    </button>
  </div>
</div>